import { axiosInstanceToken, axiosInstance, resolvePromise } from "../utils/axios";
import { daoRoute } from "../utils/config";

const loginDao = {
	login(login, password, environment) {
		return new Promise(function(resolve, reject) {
			const data = {
				login,
				password,
				environment
			};
			const loginUrl = daoRoute.login.login;

			resolvePromise(axiosInstance.post(loginUrl, data), resolve, reject);
		});
	},
	logout(token) {
		return new Promise(function(resolve, reject) {
			const logoutUrl = daoRoute.login.logout;
			if (axiosInstanceToken)
			resolvePromise(axiosInstanceToken.post(logoutUrl), resolve, reject);
		});
	}
};

export default loginDao;


// WEBPACK FOOTER //
// ./src/api/loginDao.js